import React from 'react';
import PropTypes from 'prop-types';
import geojsonExtent from '@mapbox/geojson-extent';

const IconFromCoordinates = ({ coordinates, className, width, height }) => {
  // It's only a point
  if (typeof coordinates[0] === 'number') {
    return (
      <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} className={className}>
        <circle cx={width / 2} cy={height / 2} r="2" fill="currentColor" />
      </svg>
    );
  }

  const [west, south, east, north] = geojsonExtent({ type: 'Point', coordinates });

  const scaleToCanvas = (num, min, max, scaledMax = width, scaledMin = 0) => (
    (((scaledMax - scaledMin) * (num - min)) / (max - min)) + scaledMin
  );

  const coordinatesToCanvas = coordinates.map(coordinate => (
    coordinate.map(coord => (
      coord.map((item, i) => (
        i
          ? scaleToCanvas(
            (north - (item - south)),
            south,
            north,
            height,
          )
          : scaleToCanvas(item, west, east)
      ))
    ))
  ));

  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} className={className}>
      {coordinatesToCanvas.map(coord => {
        const pathD = coord.map(f => f.join(',')).join(' ');
        return <path key={pathD} d={`M${pathD}`} fill="none" stroke="currentColor" />;
      })}
    </svg>
  );
};

IconFromCoordinates.propTypes = {
  coordinates: PropTypes.array.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

IconFromCoordinates.defaultProps = {
  className: '',
  width: 20,
  height: 20,
};

export default IconFromCoordinates;



// WEBPACK FOOTER //
// ./src/components/FormMap/IconFromCoordinates.js